function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import { SignInType } from '@domain-group/fe-allhomes-library';
import WatchlistButton from './components/watchlist-button';
import Popup from './components/popup';
import wrapper from './wrappers';
import * as styles from './allhomes-watchlist-button.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
class AllhomesWatchlistButton extends React.Component {
  constructor(props) {
    var _this;
    super(props);
    _this = this;
    _defineProperty(this, "onButtonClick", event => {
      event.preventDefault();
      event.stopPropagation();
      var isSignedIn = this.props.user && this.props.user.type === 'authenticated';
      if (this.props.media.mobile && !isSignedIn) {
        this.signInAndUpdateWatchlist();
      } else {
        this.updateWatchList();
      }
    });
    _defineProperty(this, "closePopup", () => this.setState({
      hasPopup: false
    }));
    _defineProperty(this, "onPopupSignIn", () => {
      this.closePopup();
      this.signInAndUpdateWatchlist();
    });
    _defineProperty(this, "onPopupSignUp", () => {
      this.closePopup();
      this.props.openSignUp();
    });
    _defineProperty(this, "updateWatchList", fromState => {
      this.setState({
        isLoading: true
      });
      this.props.updateWatchList(this.props.listingId, fromState).then(() => {
        this.props.onAddToWatchlist(this.props.listingId);
      }).catch(function () {
        var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _error$body = error.body,
          body = _error$body === void 0 ? {} : _error$body,
          result = error.result;
        var maxAllowed = body.maxAllowed;
        if (maxAllowed) {
          _this.setState({
            hasPopup: true,
            popupTitle: "You've hit the top!",
            popupMessage: "You can only watch ".concat(maxAllowed, " propert").concat(maxAllowed === 1 ? 'y' : 'ies', " when you\u2019re not logged in. Sign up and add as many as you like")
          });
        } else {
          console.log(error, result); // eslint-disable-line no-console
        }
      }).finally(() => {
        this.setState({
          isLoading: false
        });
      });
    });
    _defineProperty(this, "signInAndUpdateWatchlist", () => {
      var isInWatchlist = this.isInWatchlist();
      this.props.openSignIn(SignInType.WATCHLIST).then(success => {
        if (success) {
          this.updateWatchList(isInWatchlist);
        }
      });
    });
    _defineProperty(this, "updateButtonRef", buttonRef => {
      if (!isEqual(buttonRef, this.state.buttonRef)) {
        this.setState({
          buttonRef
        });
      }
    });
    _defineProperty(this, "isInWatchlist", () => this.props.watchlist && this.props.watchlist.includes(this.props.listingId));
    _defineProperty(this, "isLoading", () => this.props.isIdentityLoading || this.state.isLoading);
    this.state = {
      isLoading: false
    };
  }
  render() {
    return ___EmotionJSX("div", {
      className: this.props.className,
      css: styles.container
    }, ___EmotionJSX(WatchlistButton, {
      isInWatchlist: this.isInWatchlist(),
      isLoading: this.isLoading(),
      onClick: this.onButtonClick,
      media: this.props.media,
      noText: this.props.noText,
      inactiveColour: this.props.inactiveColour,
      activeColour: this.props.activeColour,
      setButtonRef: this.updateButtonRef
    }), this.state.hasPopup && ___EmotionJSX(Popup, {
      buttonRef: this.state.buttonRef,
      onClose: this.closePopup,
      onSignUp: this.onPopupSignUp,
      onSignIn: this.onPopupSignIn,
      align: this.props.popupAlignment,
      style: this.props.popupStyle,
      title: this.state.popupTitle,
      message: this.state.popupMessage
    }));
  }
}
AllhomesWatchlistButton.propTypes = {
  listingId: PropTypes.number.isRequired,
  onAddToWatchlist: PropTypes.func,
  isIdentityLoading: PropTypes.bool,
  watchlist: PropTypes.arrayOf(PropTypes.number),
  updateWatchList: PropTypes.func,
  user: PropTypes.shape({
    type: PropTypes.oneOf(['anonymous', 'casual', 'authenticated'])
  }),
  openSignIn: PropTypes.func,
  openSignUp: PropTypes.func,
  noText: PropTypes.bool,
  popupAlignment: PropTypes.oneOf(['right', 'center']),
  popupStyle: PropTypes.oneOf(['normal', 'squeezed']),
  media: PropTypes.objectOf(PropTypes.bool),
  className: PropTypes.string,
  inactiveColour: PropTypes.string,
  activeColour: PropTypes.string
};
AllhomesWatchlistButton.defaultProps = {
  user: {
    type: 'anonymous'
  },
  isIdentityLoading: false,
  watchlist: [],
  updateWatchList: () => {},
  onAddToWatchlist: () => {},
  openSignIn: () => {},
  openSignUp: () => {},
  popupAlignment: 'center',
  noText: false,
  media: {},
  popupStyle: 'normal',
  className: '',
  inactiveColour: undefined,
  activeColour: undefined
};
export default wrapper(AllhomesWatchlistButton);
export { AllhomesWatchlistButton as BaseAllhomesWatchlistButton };